import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { XCircle } from 'lucide-react';
export function DifferentiationSection() {
  const failedSolutions = ['Nose strips', 'Special pillows', 'Mouth tape', 'Sprays', 'Apps', 'White noise machines', 'Expensive equipment'];
  return <section className="py-24 bg-[#FDFBF7] border-y border-gray-100" data-id="element-33">
      <Container data-id="element-34">
        <div className="max-w-4xl mx-auto" data-id="element-35">
          <div className="text-center mb-16" data-id="element-36">
            <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-6" data-id="element-37">
              Why Most Snoring Solutions Fail
            </h2>
            <p className="text-xl text-gray-600 font-light" data-id="element-38">
              Most products only try to hide the sound.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-39">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-40">
              <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-41">
                That is why people spend years bouncing between solutions that
                end up sitting in a closet:
              </p>
              <div className="flex flex-wrap gap-3 mb-8" data-id="element-42">
                {failedSolutions.map((item, i) => <div key={i} className="flex items-center bg-white border border-gray-200 px-4 py-2 rounded-full text-sm text-gray-500 opacity-75" data-id="element-43">
                    <XCircle className="w-4 h-4 mr-2 text-gray-400" data-id="element-44" />
                    <span className="line-through" data-id="element-45">{item}</span>
                  </div>)}
              </div>
              <p className="text-gray-600 leading-relaxed" data-id="element-46">
                But very few products explain what is physically happening
                during sleep. Because for many people, the issue is not simply
                “snoring.”
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 space-y-6" data-id="element-47">
              <p className="text-gray-700 leading-relaxed" data-id="element-48">
                It often starts when the jaw relaxes during deep sleep and the
                airway behind the tongue narrows more than most people realize.
              </p>
              <div className="pl-4 border-l-2 border-blue-200 space-y-2" data-id="element-49">
                <p className="text-gray-800 font-medium" data-id="element-50">
                  That narrowing creates vibration.
                </p>
                <p className="text-gray-800 font-medium" data-id="element-51">
                  That vibration becomes snoring.
                </p>
              </div>
              <p className="text-gray-600 leading-relaxed" data-id="element-52">
                Which means many common solutions are only trying to soften the
                symptom instead of helping address what is causing it.
              </p>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="mt-16 text-center max-w-2xl mx-auto" data-id="element-53">
            <p className="text-xl text-gray-800 leading-relaxed font-medium mb-6" data-id="element-54">
              SnoreStop™ was designed to gently support the jaw position during
              sleep which may help reduce the airway narrowing linked to
              snoring.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-55">
              And for many couples, the difference feels noticeable surprisingly
              fast. Not because the sound is being covered up. <br data-id="element-56" />
              <br data-id="element-57" />
              <span className="font-serif text-2xl text-[#1E40AF] italic" data-id="element-58">
                Because the room finally feels quiet again.
              </span>
            </p>
          </motion.div>
        </div>
      </Container>
    </section>;
}